import appConfig from '@nerdwallet/app-config';

export default {
  featuredImageDesktop: `${appConfig.ASSETS_URL}/images/homepage/registration-module-phone-desktop.png`,
  featuredImageMobile: `${appConfig.ASSETS_URL}/images/homepage/registration-module-phone-mobile.png`,
};
